module.exports = __webpack_public_path__ + "img/labelyasanCloud.8e4af974.svg";